<template>
  <q-dialog v-model="setSellDialog.show"
            @keydown.escape="close()"
            persistent
            transition-show="scale"
            transition-hide="scale">
    <q-card>
      <q-form @submit.prevent.stop="postSellVehicles" @validation-error="onValidationError" :disabled="isLoading">
        <q-card-section>
          <div class="text-h6">Post for sell</div>
        </q-card-section>

        <q-separator/>

        <q-card-section style="position:relative; width:560px; max-height: 50vh" class="scroll">
          <div v-if="results.length > 0">
            <q-card v-for="(item, i) in results" :key="item.company_id"
                    flat
                    bordered
                    class="q-mb-md"
                    :style="i + 1 === items.length ? 'margin-bottom: 0' : ''">
              <q-list bordered>
                <q-item>
                  <q-item-section>
                    <q-item-label>
                      <strong>{{ item.company.name }}</strong>
                    </q-item-label>
                  </q-item-section>
                  <q-item-section side>
                    <q-item-label>{{ item.items.length }}</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
              <div v-for="(vehicle_item, j) in item.items" :key="vehicle_item.vehicle_id"
                   :class="'q-pa-md' + (j % 2 === 0 ? ' odd' : '')">
                <div class="row q-mb-md">
                  <div class="col-4">{{ vehicle_item.vehicle.vin }}</div>
                  <div class="col-8 text-right">{{ vehicle_item.vehicle.brand.name }} - {{
                      vehicle_item.vehicle.model.name
                    }} - {{ vehicle_item.vehicle.model_detail.name }} ({{ vehicle_item.vehicle.model_year }})
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <q-badge :color="vehicle_item.result === 'failed' ? 'red' : 'green'">
                      {{ vehicle_item.result.toUpperCase() }}
                    </q-badge>
                  </div>
                  <div class="col-8 text-right">{{ vehicle_item.message }}</div>
                </div>
              </div>
            </q-card>
          </div>
          <div v-else>
            <q-card v-for="(item, i) in items" :key="item.company_id"
                    flat
                    bordered
                    class="q-mb-md"
                    :style="i + 1 === items.length ? 'margin-bottom: 0' : ''">
              <q-list bordered>
                <q-item>
                  <q-item-section>
                    <q-item-label>
                      <strong>{{ item.company_name }}</strong>
                    </q-item-label>
                  </q-item-section>
                  <q-item-section side>
                    <q-item-label>{{ item.items.length }}</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
              <div v-for="vehicle_item in item.items" :key="vehicle_item.vehicle_id" class="q-pa-md">
                <div class="row q-mb-md">
                  <div class="col-4">{{ vehicle_item.details.vin }}</div>
                  <div class="col-8 text-right">{{ vehicle_item.details.brand }} - {{
                      vehicle_item.details.model
                    }} - {{ vehicle_item.details.model_detail }} ({{ vehicle_item.details.model_year }})
                  </div>
                </div>
                <q-card flat bordered>
                  <div class="row">
                    <div class="col-4 q-pa-sm">
                      <q-input v-model="vehicle_item.due_location_name" dense label="Due location name"
                               :rules="[val => !!val || 'Field is required']" :disable="isLoading"/>
                    </div>
                    <div class="col-4 q-pa-sm">
                      <q-input v-model="vehicle_item.pickup_location_number" dense label="Pickup location number"
                               :rules="[val => !!val || 'Field is required']" :disable="isLoading"/>
                    </div>
                    <div class="col-4 q-pa-sm">
                      <q-input v-model="vehicle_item.grade" dense type="number" label="Grade" min="1" max="5" step="any"
                               :disable="isLoading"/>
                    </div>
                    <div class="col-4 q-pa-sm">
                      <q-field v-model.lazy="vehicle_item.mileage"
                               label="Mileage"
                               dense
                               :rules="[val => !!val || 'Field is required']" :disable="isLoading">
                        <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                          <input :id="id" class="q-field__input" :value="value"
                                 @change="e => emitValue(e.target.value)" v-money="mileageFormatForDirective"
                                 v-show="floatingLabel">
                        </template>
                      </q-field>
                    </div>
                    <div class="col-4 q-pa-sm">
                      <q-input v-model="vehicle_item.status" dense label="Status"
                               :rules="[val => !!val || 'Field is required']"
                               :disable="isLoading"/>
                    </div>
                    <div class="col-4 q-pa-sm">
                      <q-field v-model.lazy="vehicle_item.price"
                               label="Price"
                               dense
                               :rules="[val => !!val || 'Field is required']" :disable="isLoading">
                        <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                          <input :id="id" class="q-field__input" :value="value"
                                 @change="e => emitValue(e.target.value)" v-money="moneyFormatForDirective"
                                 v-show="floatingLabel">
                        </template>
                      </q-field>
                    </div>
                    <div class="col-4 q-pa-sm">
                      <div style="display: flex; flex-direction: row; max-height: 50px; margin-top: -15px;">
                        <q-checkbox v-model.lazy="vehicle_item.initial_cost_selection"></q-checkbox>
                        <q-field v-model.lazy="vehicle_item.initial_cost"
                                 label="Initial cost"
                                 :rules="[val => !!val || 'Field is required']"
                                 :disable="isLoading || !vehicle_item.initial_cost_selection">
                          <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                            <input :id="id"
                                   class="q-field__input"
                                   :value="value"
                                   :disabled="isLoading || !vehicle_item.initial_cost_selection"
                                   @change="e => emitValue(e.target.value)" v-money="moneyFormatForDirective"
                                   v-show="floatingLabel">
                          </template>
                        </q-field>
                      </div>
                    </div>
                    <div class="col-4 q-pa-sm">
                      <q-toggle v-model.lazy="vehicle_item.retail" color="teal" label="Retail"/>
                    </div>
                    <div class="col-4 q-pa-sm">
                      <q-toggle v-model.lazy="vehicle_item.wholesale" color="teal" label="Wholesale"/>
                    </div>
                    <div class="col-4 q-pa-sm">
                      <q-toggle v-model.lazy="vehicle_item.is_with_mmr" color="teal" label="With MMR"/>
                    </div>
                  </div>
                </q-card>
              </div>
            </q-card>
          </div>
        </q-card-section>

        <q-separator/>

        <q-card-actions>
          <div class="row" style="width: 100%">
            <div class="col-4">
              <div class="loading" v-if="isLoading">
                <q-spinner-facebook size="45px" color="primary"/>
              </div>
              <q-btn v-if="results.length > 0" label="RE-SELL" color="secondary q-ml-sm" @click="results = []"/>
            </div>
            <div class="col-8 text-right q-pt-xs">
              <q-btn label="CLOSE" color="red" v-close-popup class="q-mr-sm" :disable="isLoading"/>
              <q-btn type="submit" label="POST FOR SELL" color="primary" :disable="isLoading || results.length > 0"/>
            </div>
          </div>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import {VMoney} from 'v-money'
import axios from "@/axios";

export default {
  name: "VehicleSellDialog",
  data() {
    return {
      items: [],
      results: [],
      isLoading: false,
      mileageFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    setSellDialog: {
      get() {
        return this.$store.state.vehicle.setSellDialog
      },
      set(val) {
        this.$store.commit('vehicle/SET_SELL_DIALOG', val)
      }
    }
  },
  methods: {
    getFormattedItems() {
      this.items = []
      this.results = []
      this.setSellDialog.items.forEach(item => {
        const companyGroup = this.items.find(i => i.company_id === item.company.id)
        if (companyGroup === undefined) {
          this.items.push({
            company_id: item.company.id,
            company_name: item.company.name,
            items: [this.getFormattedItem(item)]
          })
        } else {
          companyGroup.items.push(this.getFormattedItem(item))
        }
      })
    },
    getFormattedItem(item) {
      return {
        vehicle_id: item.id,
        due_location_name: item.location.due_location_name,
        pickup_location_number: item.location.pickup_location_number,
        grade: item.location.avg_cr,
        mileage: item.last_mileage_record.mileage,
        status: 1,
        price: item.last_mileage_record?.market_values[0][item.condition] * 100 ?? 0,
        is_with_mmr: item.is_with_mmr ?? false,
        initial_cost_selection: item.initial_cost_selection ?? false,
        initial_cost: item.purchase_amount * 100 ?? null,
        retail: item.retail ?? false,
        wholesale: item.wholesale ?? true,
        details: {
          location: item.location,
          vin: item.vin,
          brand: item.make,
          model: item.model,
          model_detail: item.model_detail,
          model_year: item.model_year,
        }
      }
    },
    onValidationError(ref) {
      ref.$el.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      })
    },
    async postSellVehicles() {
      this.isLoading = true
      const {data} = await axios.put('/sell', this.items.map(item => {
        return {
          company_id: item.company_id,
          items: item.items.map(i => {
            const itemData = {
              vehicle_id: i.vehicle_id,
              due_location_name: i.due_location_name,
              pickup_location_number: i.pickup_location_number,
              grade: i.grade,
              mileage: parseInt(i.mileage.replace(',', '')),
              status: i.status,
              price: parseInt(i.price
                .replace('$ ', '')
                .replace('.', '')
                .replace(',', '')) / 100,
              is_with_mmr: i.is_with_mmr,
              retail: i.retail,
              wholesale: i.wholesale,
            }

            if (i.initial_cost_selection === true && parseInt(itemData.initial_cost) !== 0) {
              itemData.initial_cost = parseInt(i.initial_cost
                .replace('$ ', '')
                .replace('.', '')
                .replace(',', '')) / 100
            }

            if (itemData.grade === null || itemData.grade === '') {
              delete itemData.grade
            }

            if (itemData.is_with_mmr === false) {
              delete itemData.is_with_mmr
            }

            return itemData
          })
        }
      }))
      this.results = data.data
      this.isLoading = false
      if (this.setSellDialog.nested) {
        this.close(true)
      }
    },
    close(completed = false) {
      this.loading = false
      this.results = []
      this.$store.commit('vehicle/SET_SELL_DIALOG', {
        show: false,
        items: [],
        nested: false,
        completed: completed,
      })
    }
  },
  watch: {
    setSellDialog: {
      deep: true,
      async handler(val) {
        if (val.show) {
          this.getFormattedItems()
        }
      }
    }
  },
  directives: {money: VMoney}
}
</script>

<style scoped lang="scss">
.odd {
  background-color: #f5f5f5;
}
</style>
